// extracted by mini-css-extract-plugin
export default {"container":"Payment_container__H5Mi3","containerInner":"Payment_containerInner__VfZNi","StripeElement":"Payment_StripeElement__0lDU+","Label":"Payment_Label__h3t2R"};